import React from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck, Gift } from "lucide-react";

const UpgradeButton = ({ onUpgradeClick, isLoading, isTrial }) => (
  <Button
    size="lg"
    className="w-full bg-gradient-to-r from-primary to-accent text-primary-foreground hover:opacity-90 transition-opacity text-sm sm:text-base md:text-lg py-2 md:py-6 px-2 xs:px-8"
    onClick={onUpgradeClick}
    disabled={isLoading}
  >
    {isLoading ? (
      "Processing..."
    ) : isTrial ? (
      <>
        <Gift className="mr-2 h-5 w-5 flex-shrink-0" />
        Start 30-Day Free Trial — No Card Required
      </>
    ) : (
      <>
        <ShieldCheck className="mr-2 h-5 w-5 flex-shrink-0" />
        Proceed to Secure Payment
      </>
    )}
  </Button>
);

export default React.memo(UpgradeButton);
